import React, { useEffect } from 'react';

// KA WhatsApp reminders (GRI-253) link to /assignments/<ka_id>/week-<nn>. Until
// the portal lists assignments itself, send KAs to the Apps Script KA portal,
// where they look up their assignments by KA code.
export const KA_PORTAL_URL =
  'https://script.google.com/a/macros/gritsee.com/s/AKfycbyKE1XSZffLRgguz9Vc7hOO6zxdlTBw3QptjlrmyT659Pve7kdD9Ylu_BSkWsi1Bo-S/exec';

function KaAssignments() {
  useEffect(() => {
    window.location.replace(KA_PORTAL_URL);
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      Redirigiendo al <a href={KA_PORTAL_URL}>Portal de Muestras KA</a>…
    </div>
  );
}

export default KaAssignments;
